import { ActionFunctionArgs, json, MetaFunction } from '@remix-run/node';
import { useActionData, useNavigation } from '@remix-run/react';
import ContactUs from '~/components/contact-us/ContactUs';
import { FAQSection } from '~/components/faqs/FAQSection';
import { WhyVapeStore } from '~/components/testimonials/WhyVapeStore';
import { submitContact } from '~/providers/contact/contact';
import { useRootLoader } from '~/utils/use-root-loader';

export const meta: MetaFunction = () => [{ title: 'Contact Us' }];

export const action = async ({ request }: ActionFunctionArgs) => {
  const formData = await request.formData();
  const fullName = formData.get('fullName');
  const emailAddress = formData.get('email');
  const subject = formData.get('subject');
  const message = formData.get('message');
  const consentToContact = formData.get('consentToContact') === 'on';

  if (!fullName || !emailAddress || !message) {
    return json(
      { ok: false, error: 'Please fill out all required fields.' },
      { status: 400 },
    );
  }

  try {
    const inputData = {
      fullName: String(fullName),
      emailAddress: String(emailAddress),
      subject: typeof subject === 'string' ? subject : '',
      message: String(message),
      consentToContact,
    };

    const result = await submitContact(inputData);

    if (result?.__typename === 'ContactForm') {
      return json({ ok: true, error: null });
    } else {
      const errorMessage =
        (result as any)?.message || 'An unknown GraphQL error occurred.';
      return json({ ok: false, error: errorMessage });
    }
  } catch (e: any) {
    return json(
      { ok: false, error: 'Failed to submit form.' },
      { status: 500 },
    );
  }
};

export default function Contact() {
  const actionData = useActionData<typeof action>();
  const navigation = useNavigation();
  const rootData = useRootLoader();
  const faqs = rootData?.faqs ?? [];

  return (
    <div className="min-h-screen p-6">
      <ContactUs actionData={actionData} navigation={navigation} />
      <FAQSection faqs={faqs} />
      <WhyVapeStore />
    </div>
  );
}
